import React from 'react';
import PropTypes from "prop-types";
import { useFormContext } from 'react-hook-form';
import moment from 'moment';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import AdapterMoment from "@mui/lab/AdapterMoment";
import TimePicker from '@mui/lab/TimePicker';
import { FormHelperText, InputAdornment, TextField } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const localeMap = {
    en: moment.locale("en"),
    th: moment.locale("th"),
};
const maskMap = {
    en: "dd/mm/yyyy",
    th: "วว/ดด/ปปปป",
};
export function TimePickerFormItem(props) {
    const {
        label,
        name,
        autoComplete,
        required,
        inputProps,
        minTime,
        maxTime,
        small,
        disabled,
        IsDisableIconTime
    } = props;

    const {
        register,
        setValue,
        watch,
        formState: { errors },
    } = useFormContext();

    const [locale] = React.useState<keyof typeof maskMap>("en");
    const format = "HH:mm";

    const handleChange = (date: Date, keyboardInputValue?: string) => {
        let Key = keyboardInputValue
        let Ispass = true;
        if (Key) {
            if (Key.length == 1 && Number(Key.substr(0, 1)) > 2) {
                Ispass = false;
            }
            else if (Key.length > 2) {
                if (Number(Key.substr(0, 2)) >= 24) {
                    Ispass = false;
                }
            }
            if (Key.length >= 4) {
                if (Number(Key.substr(3, 2)) > 59) {
                    Ispass = false;
                }
            }
            if (Key.length < 5) {
                Ispass = false;
            }

        }

        if (Ispass) {
            if (Key) {
                if (Key != null && Key != undefined && Key != "undefined") {
                    props.onChange && props.onChange(date);
                    setValue(name, date, { shouldValidate: true })

                } else {
                    props.onChange && props.onChange(null);
                    setValue(name, null)
                }
            } else {
                props.onChange && props.onChange(null);
                setValue(name, date, { shouldValidate: true })
            }

        } else {
            props.onChange && props.onChange(null);
            setValue(name, null)
        }

    }

    return (
        <LocalizationProvider
            dateAdapter={AdapterMoment}
            locale={localeMap[locale]}
        >
            <TimePicker
                clearable
                inputFormat={format}
                label={label}
                name={name}
                inputRef={register(name).ref}
                {...register(name)}
                ampm={false}
                minTime={minTime || undefined}
                maxTime={maxTime || undefined}
                autoComplete={autoComplete || undefined}
                onAccept={(a) => {
                    props.onAccept && props.onAccept(a);
                }}
                onChange={(date: Date, keyboardInputValue?: string) => {
                    handleChange(date, keyboardInputValue);
                }}
                value={watch(name) || null}
                autoOk
                {...inputProps}
                renderInput={(props) => (
                    <TextField
                        margin="normal"
                        variant="outlined"
                        fullWidth
                        {...props}
                        inputProps={{ ...props.inputProps, value: props.inputProps ? (Number(props.inputProps?.value.substr(0, 2)) >= 24 || Number(props.inputProps?.value.substr(3, 2)) > 59 ? "" : props.inputProps?.value) : null }}
                        required={required}
                        error={errors && errors[name]}
                        size={small ? "small" : "medium"}
                        disabled={disabled || false}
                        autoComplete={"off"}
                        style={{
                            margin: '0px'
                        }}
                        onBlur={(e) => {

                            setValue(name, watch(name) ? watch(name) : null, { shouldValidate: true });

                        }}
                        InputProps={IsDisableIconTime === true ? {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <AccessTimeIcon />
                                </InputAdornment>
                            ),
                        } : {}
                        }
                        sx={{
                            "label.MuiInputLabel-shrink": {
                                backgroundColor: "rgba(255,255,255,0.95)",
                                top: "0px",
                            },
                            ".MuiInputLabel-outlined": {
                                top: "0px",
                            },
                            ".MuiInputLabel-asterisk": {
                                color: "red"
                            },
                            ".Mui-disabled": {
                                backgroundColor: "#f1f1f1",
                                color: "#000000"

                            },
                        }}
                    />
                )}
            />
            {errors && errors[name] ? (
                <FormHelperText sx={{ color: "red" }}>
                    {errors[name].message}
                </FormHelperText>
            ) : null}
        </LocalizationProvider>
    );
}

TimePickerFormItem.defaultProps = {
    label: "",
    lableEnd: "",
    small: true,
    required: false,
    calendarsCount: 1,
    fullWidth: true,
    IsDisableIconTime: true,
};

TimePickerFormItem.propTypes = {
    form: PropTypes.object,
    name: PropTypes.string.isRequired,
    required: PropTypes.bool,
    label: PropTypes.string,
    hint: PropTypes.string,
    autoFocus: PropTypes.bool,
    disabled: PropTypes.bool,
    IsDisableIconTime: PropTypes.bool,
    size: PropTypes.string,
    prefix: PropTypes.string,
    placeholder: PropTypes.string,
    errorMessage: PropTypes.string,
    inputProps: PropTypes.object,
    onChange: PropTypes.func,
    onAccept: PropTypes.func,
    value: PropTypes.string,
    minTime: PropTypes.any,
    maxTime: PropTypes.any,

};

export default TimePickerFormItem;